import { IMobileOrchestrator } from "@nju/data-access-portal-orchestrator";
import { Icon } from "@nju/icons";
import { Button, Heading, Panel, Separator, Text } from "@nju/ui";
import { getStatusBadge } from "../partials/getStatusBadge";
import { StatusBadge } from "../partials/StatusBadge";
import type { IPhaseProps } from "../partials/types";

interface ICustomerStatusMobileOrderCardProps {
  phase: IPhaseProps;
  mobile: IMobileOrchestrator | undefined;
  primaryMsisdn: string | undefined;
  selectedMsisdn: string | undefined;
  handleCopyToClipboard: (text: string) => Promise<void>;
}

export function CustomerStatusMobileOrderCard({
  phase,
  mobile,
  primaryMsisdn,
  selectedMsisdn,
  handleCopyToClipboard,
}: ICustomerStatusMobileOrderCardProps) {
  const badge = getStatusBadge({
    phase,
    primaryMsisdn,
    selectedMsisdn,
    phaseType: "mobile",
  });
  const orderId = mobile?.orderId;
  const testDataText = selectedMsisdn
    ? "fulfillment-status-section"
    : "msisdn-status-section";

  return (
    <div data-cy={testDataText}>
      <Panel
        badge={{
          body: badge && (
            <StatusBadge icon={badge.iconName} text={badge.text} />
          ),
          variant: "ripeLemon",
        }}
        forceShowTitleBlock={true}
        height="full"
        iconName="mobile"
        invisibleSeparator={true}
        separatorSize="none"
      >
        <div className="flex flex-col justify-between">
          <div>
            <Separator size="xs" tone="invisible" />
            <Heading font="ttfirs" tone="neutral" variant="h3" weight="bold">
              nju subskrypcja z TV
            </Heading>
          </div>
          <Separator size="xs" tone="invisible" />
          {primaryMsisdn && (
            <div>
              <Text weight="bold">numer usługi:</Text>
              <Text className="pl-1" tone="accent" weight="bold">
                {primaryMsisdn}
              </Text>
            </div>
          )}
          {orderId && selectedMsisdn && (
            <>
              <div className="flex flex-row">
                <Text className="min-w-[108px]" weight="bold">
                  nr zamówienia:
                </Text>
                <Text className="pl-1" tone="accent" weight="bold">
                  {orderId ? orderId : "w trakcie konfiguracji"}
                </Text>
                <Text weight="bold">
                  {orderId && (
                    <Button
                      display="inline"
                      onPress={() => {
                        handleCopyToClipboard(orderId as string);
                      }}
                      size="inline"
                      variant="simple"
                    >
                      <Icon className="ml-2 mb-2" name="copy" />
                    </Button>
                  )}
                </Text>
              </div>
              <Separator size="xs" tone="invisible" />
            </>
          )}
        </div>
      </Panel>
    </div>
  );
}
